var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWorldbusiness(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 812,
    viewBox: "0 0 1440 812",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5995 -713.857C10.7302 -638.553 29.2735 -551.49 64.7773 -455.607C-279.858 -162.532 -354.483 64.0587 -101.887 50.2642C-128.345 -73.4335 -133.772 -199.845 -118.395 -325.578C-312.196 -315.175 -254.756 -488.85 9.5995 -713.857Z",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-118.393 -325.581C-133.997 -199.848 -128.343 -73.21 -101.885 50.2616C150.485 36.4671 634.648 -212.285 979.283 -505.361C893.802 -598.53 803.573 -681.522 711.309 -751.852C446.953 -527.07 75.4075 -336.209 -118.393 -325.581Z",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M64.7772 -455.61C101.638 -356.336 155.006 -251.633 223.526 -144.444C-150.507 173.733 -231.464 419.545 42.6157 404.394C-25.9042 297.205 -74.7502 178.03 -101.887 50.0352C-354.483 64.0558 -279.858 -162.535 64.7772 -455.61Z",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M107.064 -354.526C-253.853 -47.6565 -331.871 189.563 -67.5149 175.09",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M160.209 -250.729C-210.432 64.7336 -290.938 308.285 -19.3454 293.36",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M-101.887 50.2628C-74.524 178.257 -25.9042 297.432 42.6158 404.622C316.696 389.697 842.015 119.687 1215.82 -198.489C1147.3 -305.679 1067.48 -409.024 979.055 -505.359C634.646 -212.51 150.484 36.4683 -101.887 50.2628Z",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M-67.5156 175.091C196.84 160.618 703.843 -99.8933 1064.76 -406.989",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M-19.3457 293.361C252.247 278.436 773.043 10.9143 1143.68 -304.549",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M214.027 -34.9912C259.255 88.0281 316.92 204.942 385.666 312.131",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M601.854 -234.221C669.017 -122.508 737.763 -11.2482 806.509 95.9415",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M1396.96 -747.554C1465.48 -640.364 1514.33 -521.189 1541.46 -393.195C1289.09 -379.4 804.929 -130.648 460.294 162.427C371.874 65.8663 292.047 -37.2528 223.527 -144.442C597.56 -462.619 1122.88 -732.629 1396.96 -747.554Z",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M1507.09 -518.023C1242.73 -503.551 735.731 -243.039 374.814 64.0569",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M223.753 -144.442C292.273 -37.2528 372.099 66.0925 460.52 162.428C115.885 455.729 41.2589 682.094 293.629 668.299C195.711 600.458 111.136 511.585 42.6158 404.622C-231.464 419.547 -150.28 173.734 223.753 -144.442Z",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M295.892 -38.6104C-74.7488 276.627 -155.254 520.178 116.564 505.479",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M375.039 63.8301C14.1217 370.926 -64.1222 607.919 200.234 593.673",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M-50.3262 142.528C18.1938 249.718 105.257 345.374 207.924 427.01",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M-115.23 339.494C-46.7105 446.684 41.9358 537.139 148.221 608.373",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M42.6172 404.396C111.137 511.585 195.713 600.231 293.631 668.073C546.001 654.278 1030.16 405.526 1374.8 112.451C1337.94 13.1759 1284.57 -91.5262 1216.05 -198.716C842.017 119.461 316.697 389.47 42.6172 404.396Z",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M116.562 505.479C388.155 490.554 908.726 223.032 1279.37 -92.4307",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M200.234 593.673C464.59 579.2 971.593 318.689 1332.51 11.5928",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M385.441 312.132C453.961 419.321 529.492 510.455 609.545 583.272",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M806.514 95.7168C875.034 202.906 939.483 299.92 997.601 383.817",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M1216.05 -198.715C1284.57 -91.5252 1338.17 13.1768 1374.8 112.452C1719.44 -180.624 1794.06 -407.214 1541.69 -393.42C1514.33 -521.414 1465.71 -640.589 1397.19 -747.779C1671.04 -762.478 1589.86 -516.665 1216.05 -198.715Z",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M1332.51 11.5935C1693.43 -295.276 1771.67 -532.496 1507.09 -518.023",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M1541.46 -393.193C1567.92 -269.722 1573.35 -143.084 1557.97 -17.3512C1364.17 -6.72268 992.851 184.138 728.269 409.146C636.004 338.817 546.001 255.824 460.295 162.655C805.156 -130.647 1289.09 -379.399 1541.46 -393.193Z",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M1560.91 -268.817C1324.14 -255.927 870.509 -22.5526 547.357 252.206",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M1566.56 -143.311C1349.47 -131.551 933.376 82.3756 636.908 334.52",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M1225.55 -308.166C1269.19 -189.217 1299.5 -69.3638 1315.33 47.7759",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M837.721 -108.712C902.622 -0.617737 963.227 103.406 1017.73 200.872",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M460.52 162.428C546 255.597 636.229 338.59 728.494 408.919C463.912 633.926 406.472 807.827 600.273 797.198C491.501 777.298 388.155 733.88 293.629 668.299C41.2588 682.094 115.885 455.729 460.52 162.428Z",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M547.357 252.205C224.205 526.963 154.328 739.307 391.095 726.417",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M636.909 334.519C340.668 586.663 276.444 781.368 493.537 769.383",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M207.922 427.01C307.197 505.706 417.1 567.894 534.466 611.991",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M148.221 608.373C250.888 677.119 365.314 725.287 488.785 751.292",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M293.631 668.3C388.157 733.88 491.502 777.298 600.275 797.199C794.075 786.57 1165.39 595.709 1429.98 370.701C1428.85 295.397 1410.3 208.334 1374.8 112.451C1030.16 405.753 546.227 654.505 293.631 668.3Z",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M391.096 726.416C627.863 713.527 1081.5 480.152 1404.65 205.394",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M493.539 769.384C710.632 757.625 1126.73 543.698 1423.19 291.554",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M609.545 583.271C686.884 653.374 765.354 703.577 842.694 732.071",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M997.371 383.817C1053.45 465.001 1101.62 530.581 1140.29 578.975",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M1374.8 112.678C1410.3 208.561 1428.85 295.398 1429.98 370.928C1694.33 145.921 1751.77 -27.7537 1557.97 -17.1252C1573.58 -142.858 1567.92 -269.496 1541.46 -392.967C1794.06 -406.988 1719.44 -180.623 1374.8 112.678Z",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M1404.65 205.395C1727.8 -69.3628 1797.68 -281.707 1560.91 -268.817",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M1422.97 291.554C1719.44 39.6354 1783.66 -155.07 1566.57 -143.311",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M1557.97 -17.3516C1542.37 108.381 1506.64 227.33 1451.69 335.877C1344.95 341.756 1140.52 446.911 994.889 570.608C910.313 533.748 820.536 479.475 728.271 409.145C992.853 184.138 1364.17 -6.72306 1557.97 -17.3516Z",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M1535.81 105.894C1368.47 114.939 1048.03 279.794 819.633 474.047",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M1500.31 223.938C1362.14 231.401 1097.33 367.536 908.732 528.095",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M1315.55 47.7754C1331.61 165.141 1332.51 274.14 1318.26 371.606",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M1017.95 200.872C1072.68 298.338 1118.58 384.27 1154.31 455.956",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M728.269 409.145C820.534 479.474 910.311 533.973 994.887 570.607C849.253 694.531 817.82 790.188 924.331 784.308C818.046 812.802 709.048 817.325 600.275 797.198C406.474 807.827 463.914 633.926 728.269 409.145Z",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M819.63 474.047C591.456 668.3 541.932 818.23 709.048 809.184",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M908.727 528.093C720.128 688.425 679.423 812.349 817.367 804.886",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M534.469 611.991C651.835 656.088 770.783 679.833 888.149 682.32",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M488.564 751.292C612.036 777.298 737.995 779.785 862.824 758.981",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M600.273 797.198C709.046 817.325 818.271 812.802 924.33 784.308C1031.07 778.429 1235.5 673.275 1381.13 549.577C1414.6 506.384 1431.11 446.231 1429.98 370.701C1165.62 595.709 794.074 786.57 600.273 797.198Z",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M709.045 809.183C876.387 800.137 1196.83 635.282 1425.23 441.029",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M817.367 804.887C955.538 797.424 1220.35 661.289 1408.95 500.73",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M842.691 731.845C920.031 760.338 992.395 765.765 1057.75 748.353",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M1140.29 578.974C1178.96 627.367 1206.33 656.087 1221.7 664.228",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M1429.97 370.7C1431.11 446.005 1414.6 506.157 1381.13 549.576C1526.76 425.652 1558.2 329.996 1451.68 335.875C1506.64 227.329 1542.59 108.38 1557.97 -17.3531C1751.77 -27.9816 1694.33 145.919 1429.97 370.7Z",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M1425.23 441.029C1653.4 246.776 1702.92 96.8461 1535.81 105.892",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M1408.95 500.73C1597.54 340.398 1638.25 216.474 1500.31 223.936",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M1451.69 335.875C1395.83 446.004 1322.56 540.53 1233.24 616.739C1230.98 616.965 1226.45 619.226 1223.29 621.94C1157.71 625.558 1080.82 607.919 995.113 570.833C1140.52 446.683 1344.95 341.755 1451.69 335.875Z",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M1318.26 371.829C1303.79 470.652 1274.39 553.644 1230.3 617.416",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M1154.32 455.953C1190.72 528.77 1215.15 583.948 1226.68 619.225",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M994.886 570.608C1080.59 607.921 1157.71 625.334 1223.06 621.716C1219.89 624.429 1219.22 626.465 1221.48 626.465C1132.15 702.447 1031.97 755.363 924.331 784.309C817.82 790.189 849.253 694.532 994.886 570.608Z",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M888.375 682.322C1007.32 685.035 1119.26 665.587 1221.02 624.204",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M863.049 758.982C989.686 737.725 1110.22 693.402 1220.35 626.013",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M924.557 784.308C1032.2 755.362 1132.38 702.445 1221.7 626.463C1223.96 626.237 1228.49 623.975 1231.65 621.262C1297.23 617.643 1347.21 593.22 1381.13 549.35C1235.5 673.273 1031.07 778.428 924.557 784.308Z",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M1057.98 748.351C1124.24 730.486 1180.55 689.555 1224.64 625.784",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M1221.7 664.228C1237.08 672.595 1239.57 659.253 1228.03 623.976",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M1381.13 549.576C1347.21 593.447 1297.01 617.87 1231.65 621.488C1234.82 618.774 1235.5 616.739 1233.24 616.739C1322.56 540.757 1395.83 446.005 1451.69 335.875C1558.2 329.996 1526.76 425.652 1381.13 549.576Z",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M1487.87 437.864C1420.93 516.334 1335.67 577.392 1234.14 619.001",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M1513.2 361.202C1438.34 463.417 1344.95 549.802 1234.59 617.191",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M447.181 -1114.58C449.443 -1115.25 470.7 -1121.36 497.158 -1127.69C525.199 -1134.25 547.361 -1138.09 547.587 -1138.09C560.477 -1140.36 577.889 -1142.84 591.005 -1144.88C598.016 -1145.78 607.287 -1146.91 614.298 -1147.59C620.856 -1148.27 629.449 -1149.18 636.007 -1149.63C644.826 -1150.31 656.812 -1151.21 665.857 -1151.66C614.976 -1148.72 564.773 -1140.58 515.023 -1127.24C405.119 -1097.62 303.131 -1043.34 211.545 -965.551C303.131 -1043.34 405.119 -1097.62 515.023 -1127.24C564.773 -1140.58 614.976 -1148.72 665.405 -1151.44C702.039 -1153.47 729.628 -1152.79 730.759 -1152.79C757.895 -1152.12 757.895 -1152.12 773.273 -1151.44C790.233 -1150.53 797.47 -1149.85 815.109 -1148.27C825.511 -1147.37 839.305 -1145.78 849.482 -1144.2C861.693 -1142.62 877.975 -1139.9 890.186 -1137.87C902.85 -1135.83 931.57 -1129.95 950.792 -1125.2C956.671 -1123.62 964.812 -1121.81 970.692 -1120.23C976.571 -1118.65 984.26 -1116.61 990.14 -1115.03C996.019 -1113.45 1003.93 -1111.18 1009.59 -1109.15C1021.12 -1105.53 1036.27 -1100.56 1047.58 -1096.71C1069.06 -1089.02 1085.12 -1082.69 1085.34 -1082.46C1096.42 -1077.94 1111.12 -1071.84 1121.98 -1066.86C1133.96 -1061.43 1146.18 -1055.78 1157.93 -1049.9C1169.69 -1044.02 1181.68 -1037.69 1193.21 -1031.36C1203.61 -1025.7 1217.41 -1017.56 1227.58 -1011.46C1227.81 -1011.46 1243.41 -1001.96 1261.28 -990.2C1271.46 -983.416 1285.02 -973.918 1294.97 -966.908C1297.24 -965.325 1318.04 -950.4 1343.59 -929.369C1368.92 -908.338 1389.5 -889.116 1389.73 -888.89C1409.17 -870.347 1409.17 -870.347 1418.9 -860.397C1427.49 -851.804 1438.57 -839.818 1446.71 -830.773C1478.37 -795.721 1508 -757.73 1534.68 -717.93C1561.37 -677.903 1585.34 -636.067 1605.69 -593.101C1611.57 -580.664 1617.22 -568.452 1622.42 -556.014C1627.17 -544.708 1633.28 -529.782 1637.57 -518.249C1637.57 -518.023 1647.75 -491.565 1657.47 -460.358C1660.19 -451.086 1664.03 -438.422 1668.78 -421.01C1672.17 -407.668 1672.17 -407.668 1678.28 -381.209C1681.67 -366.058 1687.1 -337.112 1689.59 -320.378C1692.3 -301.156 1695.92 -277.186 1698.41 -241.23C1699.31 -228.114 1699.99 -214.545 1700.44 -201.429C1700.89 -189.444 1700.89 -173.614 1700.89 -161.629C1700.89 -161.403 1700.89 -144.216 1699.54 -121.376C1698.86 -109.391 1697.73 -93.5613 1696.6 -81.576C1696.14 -75.4703 1695.24 -67.3292 1694.56 -61.4496C1693.88 -55.57 1692.75 -47.4291 1692.07 -41.5495C1691.39 -35.4437 1690.04 -27.3027 1689.13 -21.197C1689.13 -20.9709 1686.42 -3.55823 1681.9 19.0556C1679.18 32.8501 1679.18 32.85 1673.08 59.3082C1669.91 72.8765 1662.9 99.1086 1656.57 119.687C1654.31 127.15 1650.01 140.718 1643.45 159.488C1639.38 171.247 1633.28 186.624 1628.75 198.157C1626.27 204.263 1622.88 212.178 1620.39 218.284C1617.9 223.937 1614.51 231.626 1612.02 237.279C1609.31 243.385 1605.46 251.3 1602.52 257.406C1596.87 268.939 1595.51 271.652 1582.62 296.301C1579.46 302.407 1574.71 310.548 1571.32 316.654C1560.01 336.328 1548.02 355.776 1535.59 374.319C1508.9 414.12 1479.28 452.337 1447.17 487.841C1380.91 560.883 1304.47 623.298 1219.9 673.5C1205.42 682.094 1203.16 683.45 1181 695.436C1173.76 699.28 1164.27 704.255 1156.8 707.873C1144.82 713.753 1128.76 721.442 1116.55 726.869C1106.83 731.166 1093.94 736.593 1083.99 740.663C1076.3 743.829 1065.9 747.9 1057.98 750.613C1045.09 755.136 1027.68 761.242 1014.79 765.312C1008 767.574 998.959 770.288 992.175 772.097C981.999 775.036 968.43 778.655 958.254 781.368C924.107 789.962 896.066 794.937 885.438 796.746C878.201 798.103 868.703 799.686 861.467 800.59C855.135 801.495 846.542 802.625 839.984 803.53C832.973 804.434 823.702 805.565 816.691 806.017C803.802 807.148 786.841 808.505 773.951 809.183C763.097 809.862 748.398 810.314 737.543 810.54C730.985 810.766 722.166 810.766 715.381 810.766C702.944 810.54 686.21 810.088 673.546 809.636C655.455 808.957 626.509 806.47 610.453 804.661C583.543 801.495 583.543 801.495 569.296 799.233C549.848 796.293 536.054 793.58 528.591 791.997C498.741 786.117 472.056 779.107 468.664 778.202C443.337 771.418 442.885 771.192 429.769 767.122C410.547 761.242 395.622 756.041 391.551 754.458C383.41 751.518 371.199 747.221 354.012 740.437C342.931 735.914 328.232 729.809 317.378 724.834C305.392 719.406 293.181 713.753 281.422 707.873C266.044 700.185 256.547 694.983 246.144 689.33C245.466 688.878 230.314 680.737 211.771 669.43C199.56 662.193 197.072 660.61 178.076 648.173C172.875 644.781 166.091 640.258 160.89 636.64C155.915 633.022 149.131 628.273 143.93 624.654C138.955 621.036 132.397 616.061 127.421 612.443C114.532 602.945 93.2746 585.759 79.4801 573.999C66.3641 562.692 46.69 545.506 20.0057 518.369C15.7091 514.073 10.0556 508.193 5.75899 503.67C-13.0105 483.318 -15.0458 481.283 -21.6038 473.368C-25.6743 468.619 -30.8754 462.513 -34.9459 457.764C-38.7903 453.015 -43.9915 446.683 -47.8358 441.935C-56.6552 430.854 -56.6552 430.854 -72.7111 409.371C-82.2089 396.707 -98.0386 373.415 -107.536 358.49C-116.356 344.469 -131.055 321.177 -148.92 287.708C-155.478 275.497 -161.357 263.511 -167.463 251.074C-172.664 239.993 -179.222 225.068 -184.197 213.987C-186.685 208.334 -189.851 200.871 -192.112 194.991C-194.374 189.338 -197.313 181.649 -199.575 175.996C-201.836 170.342 -204.55 162.654 -206.585 156.774C-213.369 138.004 -217.892 123.079 -219.475 118.104C-223.545 104.988 -223.545 104.988 -230.782 78.7562C-232.365 72.8766 -234.4 64.7357 -235.757 58.8561C-238.471 46.8707 -242.089 31.041 -244.35 18.8295C-250.456 -12.3776 -258.597 -62.1281 -261.537 -120.924C-262.893 -147.156 -263.12 -174.745 -262.215 -200.751C-261.084 -234.672 -258.371 -262.939 -256.335 -280.804C-253.17 -308.167 -248.873 -335.077 -243.672 -361.083C-235.983 -399.3 -227.616 -429.829 -224.224 -441.362C-220.832 -452.895 -211.786 -483.876 -197.766 -520.737C-183.067 -559.406 -170.177 -586.317 -163.845 -599.207C-162.262 -602.373 -154.573 -618.655 -143.945 -638.103C-135.578 -653.706 -133.316 -657.324 -121.783 -676.999C-114.773 -688.758 -111.155 -694.411 -96.9079 -716.12C-92.6112 -722.678 -86.7316 -731.272 -82.2089 -737.604C-74.5202 -748.458 -63.8917 -762.479 -55.9768 -773.107C-50.5495 -780.118 -43.3131 -789.389 -37.6596 -796.173C-29.2925 -806.124 -17.9856 -819.466 -9.16616 -829.19C0.331657 -839.592 13.2216 -853.386 23.1716 -863.337C41.9411 -882.106 62.0674 -900.649 82.8722 -918.514C103.451 -935.927 126.743 -954.244 146.643 -968.491C157.046 -975.727 165.865 -982.059 182.147 -992.688C196.168 -1001.96 201.369 -1004.9 218.329 -1015.3C230.314 -1022.54 238.682 -1027.06 256.999 -1037.01C264.009 -1040.86 273.733 -1045.83 280.969 -1049.45C292.955 -1055.33 309.237 -1063.02 321.448 -1068.44C331.172 -1072.74 344.062 -1078.17 353.786 -1082.01C360.344 -1084.5 369.163 -1088.12 375.721 -1090.38C383.184 -1093.09 393.134 -1096.71 400.597 -1099.2C415.296 -1104.85 433.387 -1110.51 447.181 -1114.58Z",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M447.181 -1114.58C449.443 -1115.25 470.7 -1121.36 497.158 -1127.69C525.199 -1134.25 547.361 -1138.09 547.587 -1138.09C560.477 -1140.36 577.889 -1142.84 591.005 -1144.88C598.016 -1145.78 607.287 -1146.91 614.298 -1147.59C620.856 -1148.27 629.449 -1149.18 636.007 -1149.63C644.826 -1150.31 656.812 -1151.21 665.857 -1151.66C614.976 -1148.72 564.773 -1140.58 515.023 -1127.24C405.119 -1097.62 303.131 -1043.34 211.545 -965.551C303.131 -1043.34 405.119 -1097.62 515.023 -1127.24C564.773 -1140.58 614.976 -1148.72 665.405 -1151.44C702.039 -1153.47 729.628 -1152.79 730.759 -1152.79C757.895 -1152.12 757.895 -1152.12 773.273 -1151.44C790.233 -1150.53 797.47 -1149.85 815.109 -1148.27C825.511 -1147.37 839.305 -1145.78 849.482 -1144.2C861.693 -1142.62 877.975 -1139.9 890.186 -1137.87C902.85 -1135.83 931.57 -1129.95 950.792 -1125.2C956.671 -1123.62 964.812 -1121.81 970.692 -1120.23C976.571 -1118.65 984.26 -1116.61 990.14 -1115.03C996.019 -1113.45 1003.93 -1111.18 1009.59 -1109.15C1021.12 -1105.53 1036.27 -1100.56 1047.58 -1096.71C1069.06 -1089.02 1085.12 -1082.69 1085.34 -1082.46C1096.42 -1077.94 1111.12 -1071.84 1121.98 -1066.86C1133.96 -1061.43 1146.18 -1055.78 1157.93 -1049.9C1169.69 -1044.02 1181.68 -1037.69 1193.21 -1031.36C1203.61 -1025.7 1217.41 -1017.56 1227.58 -1011.46C1227.81 -1011.46 1243.41 -1001.96 1261.28 -990.2C1271.46 -983.416 1285.02 -973.918 1294.97 -966.908C1297.24 -965.325 1318.04 -950.4 1343.59 -929.369C1368.92 -908.338 1389.5 -889.116 1389.73 -888.89C1409.17 -870.347 1409.17 -870.347 1418.9 -860.397C1427.49 -851.804 1438.57 -839.818 1446.71 -830.773C1478.37 -795.721 1508 -757.73 1534.68 -717.93C1561.37 -677.903 1585.34 -636.067 1605.69 -593.101C1611.57 -580.664 1617.22 -568.452 1622.42 -556.014C1627.17 -544.708 1633.28 -529.782 1637.57 -518.249C1637.57 -518.023 1647.75 -491.565 1657.47 -460.358C1660.19 -451.086 1664.03 -438.422 1668.78 -421.01C1672.17 -407.668 1672.17 -407.668 1678.28 -381.209C1681.67 -366.058 1687.1 -337.112 1689.59 -320.378C1692.3 -301.156 1695.92 -277.186 1698.41 -241.23C1699.31 -228.114 1699.99 -214.545 1700.44 -201.429C1700.89 -189.444 1700.89 -173.614 1700.89 -161.629C1700.89 -161.403 1700.89 -144.216 1699.54 -121.376C1698.86 -109.391 1697.73 -93.5613 1696.6 -81.576C1696.14 -75.4703 1695.24 -67.3292 1694.56 -61.4496C1693.88 -55.57 1692.75 -47.4291 1692.07 -41.5495C1691.39 -35.4437 1690.04 -27.3027 1689.13 -21.197C1689.13 -20.9709 1686.42 -3.55823 1681.9 19.0556C1679.18 32.8501 1679.18 32.85 1673.08 59.3082C1669.91 72.8765 1662.9 99.1086 1656.57 119.687C1654.31 127.15 1650.01 140.718 1643.45 159.488C1639.38 171.247 1633.28 186.624 1628.75 198.157C1626.27 204.263 1622.88 212.178 1620.39 218.284C1617.9 223.937 1614.51 231.626 1612.02 237.279C1609.31 243.385 1605.46 251.3 1602.52 257.406C1596.87 268.939 1595.51 271.652 1582.62 296.301C1579.46 302.407 1574.71 310.548 1571.32 316.654C1560.01 336.328 1548.02 355.776 1535.59 374.319C1508.9 414.12 1479.28 452.337 1447.17 487.841C1380.91 560.883 1304.47 623.298 1219.9 673.5C1205.42 682.094 1203.16 683.45 1181 695.436C1173.76 699.28 1164.27 704.255 1156.8 707.873C1144.82 713.753 1128.76 721.442 1116.55 726.869C1106.83 731.166 1093.94 736.593 1083.99 740.663C1076.3 743.829 1065.9 747.9 1057.98 750.613C1045.09 755.136 1027.68 761.242 1014.79 765.312C1008 767.574 998.959 770.288 992.175 772.097C981.999 775.036 968.43 778.655 958.254 781.368C924.107 789.962 896.066 794.937 885.438 796.746C878.201 798.103 868.703 799.686 861.467 800.59C855.135 801.495 846.542 802.625 839.984 803.53C832.973 804.434 823.702 805.565 816.691 806.017C803.802 807.148 786.841 808.505 773.951 809.183C763.097 809.862 748.398 810.314 737.543 810.54C730.985 810.766 722.166 810.766 715.381 810.766C702.944 810.54 686.21 810.088 673.546 809.636C655.455 808.957 626.509 806.47 610.453 804.661C583.543 801.495 583.543 801.495 569.296 799.233C549.848 796.293 536.054 793.58 528.591 791.997C498.741 786.117 472.056 779.107 468.664 778.202C443.337 771.418 442.885 771.192 429.769 767.122C410.547 761.242 395.622 756.041 391.551 754.458C383.41 751.518 371.199 747.221 354.012 740.437C342.931 735.914 328.232 729.809 317.378 724.834C305.392 719.406 293.181 713.753 281.422 707.873C266.044 700.185 256.547 694.983 246.144 689.33C245.466 688.878 230.314 680.737 211.771 669.43C199.56 662.193 197.072 660.61 178.076 648.173C172.875 644.781 166.091 640.258 160.89 636.64C155.915 633.022 149.131 628.273 143.93 624.654C138.955 621.036 132.397 616.061 127.421 612.443C114.532 602.945 93.2746 585.759 79.4801 573.999C66.3641 562.692 46.69 545.506 20.0057 518.369C15.7091 514.073 10.0556 508.193 5.75899 503.67C-13.0105 483.318 -15.0458 481.283 -21.6038 473.368C-25.6743 468.619 -30.8754 462.513 -34.9459 457.764C-38.7903 453.015 -43.9915 446.683 -47.8358 441.935C-56.6552 430.854 -56.6552 430.854 -72.7111 409.371C-82.2089 396.707 -98.0386 373.415 -107.536 358.49C-116.356 344.469 -131.055 321.177 -148.92 287.708C-155.478 275.497 -161.357 263.511 -167.463 251.074C-172.664 239.993 -179.222 225.068 -184.197 213.987C-186.685 208.334 -189.851 200.871 -192.112 194.991C-194.374 189.338 -197.313 181.649 -199.575 175.996C-201.836 170.342 -204.55 162.654 -206.585 156.774C-213.369 138.004 -217.892 123.079 -219.475 118.104C-223.545 104.988 -223.545 104.988 -230.782 78.7562C-232.365 72.8766 -234.4 64.7357 -235.757 58.8561C-238.471 46.8707 -242.089 31.041 -244.35 18.8295C-250.456 -12.3776 -258.597 -62.1281 -261.537 -120.924C-262.893 -147.156 -263.12 -174.745 -262.215 -200.751C-261.084 -234.672 -258.371 -262.939 -256.335 -280.804C-253.17 -308.167 -248.873 -335.077 -243.672 -361.083C-235.983 -399.3 -227.616 -429.829 -224.224 -441.362C-220.832 -452.895 -211.786 -483.876 -197.766 -520.737C-183.067 -559.406 -170.177 -586.317 -163.845 -599.207C-162.262 -602.373 -154.573 -618.655 -143.945 -638.103C-135.578 -653.706 -133.316 -657.324 -121.783 -676.999C-114.773 -688.758 -111.155 -694.411 -96.9079 -716.12C-92.6112 -722.678 -86.7316 -731.272 -82.2089 -737.604C-74.5202 -748.458 -63.8917 -762.479 -55.9768 -773.107C-50.5495 -780.118 -43.3131 -789.389 -37.6596 -796.173C-29.2925 -806.124 -17.9856 -819.466 -9.16616 -829.19C0.331657 -839.592 13.2216 -853.386 23.1716 -863.337C41.9411 -882.106 62.0674 -900.649 82.8722 -918.514C103.451 -935.927 126.743 -954.244 146.643 -968.491C157.046 -975.727 165.865 -982.059 182.147 -992.688C196.168 -1001.96 201.369 -1004.9 218.329 -1015.3C230.314 -1022.54 238.682 -1027.06 256.999 -1037.01C264.009 -1040.86 273.733 -1045.83 280.969 -1049.45C292.955 -1055.33 309.237 -1063.02 321.448 -1068.44C331.172 -1072.74 344.062 -1078.17 353.786 -1082.01C360.344 -1084.5 369.163 -1088.12 375.721 -1090.38C383.184 -1093.09 393.134 -1096.71 400.597 -1099.2C415.296 -1104.85 433.387 -1110.51 447.181 -1114.58Z",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5995 -713.857C10.7302 -638.553 29.2735 -551.49 64.7773 -455.607C-279.858 -162.532 -354.483 64.0587 -101.887 50.2642C-128.345 -73.4335 -133.772 -199.845 -118.395 -325.578C-312.196 -315.175 -254.756 -488.85 9.5995 -713.857Z",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M-118.393 -325.578C-133.997 -199.845 -128.343 -73.2071 -101.885 50.2645C150.485 36.47 634.648 -212.282 979.283 -505.358C893.802 -598.527 803.573 -681.52 711.309 -751.849C446.953 -527.067 75.4075 -336.206 -118.393 -325.578Z",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M64.7772 -455.607C101.638 -356.333 155.006 -251.631 223.526 -144.441C-150.507 173.736 -231.464 419.548 42.6157 404.397C-25.9042 297.207 -74.7502 178.032 -101.887 50.0381C-354.483 64.0587 -279.858 -162.532 64.7772 -455.607Z",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M107.064 -354.523C-253.853 -47.6535 -331.871 189.566 -67.5149 175.093",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M160.209 -250.725C-210.432 64.7385 -290.938 308.29 -19.3454 293.364",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M-101.889 50.2667C-74.5259 178.261 -25.9061 297.436 42.6138 404.626C316.694 389.7 842.013 119.691 1215.82 -198.486C1147.3 -305.675 1067.47 -409.02 979.053 -505.355C634.644 -212.506 150.482 36.4722 -101.889 50.2667Z",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M-67.5176 175.095C196.838 160.622 703.841 -99.8894 1064.76 -406.985",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M-19.3477 293.365C252.245 278.44 773.042 10.9182 1143.68 -304.545",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M214.025 -34.9873C259.253 88.032 316.918 204.946 385.664 312.135",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M601.852 -234.215C669.015 -122.502 737.761 -11.2423 806.507 95.9473",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M1396.96 -747.551C1465.48 -640.361 1514.33 -521.186 1541.46 -393.192C1289.09 -379.397 804.929 -130.645 460.294 162.43C371.874 65.8693 292.047 -37.2499 223.527 -144.44C597.56 -462.616 1122.88 -732.626 1396.96 -747.551Z",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M1507.09 -518.021C1242.73 -503.548 735.731 -243.036 374.814 64.0599",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M223.753 -144.439C292.273 -37.2498 372.099 66.0955 460.52 162.43C115.885 455.732 41.2589 682.097 293.629 668.302C195.711 600.461 111.136 511.588 42.6158 404.625C-231.464 419.55 -150.28 173.737 223.753 -144.439Z",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M295.892 -38.6074C-74.7488 276.63 -155.254 520.181 116.564 505.482",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M375.039 63.833C14.1217 370.929 -64.1222 607.922 200.234 593.676",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M-50.3262 142.531C18.1938 249.721 105.257 345.377 207.924 427.013",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M-115.23 339.497C-46.7105 446.687 41.9358 537.142 148.221 608.376",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M42.6172 404.398C111.137 511.588 195.713 600.234 293.631 668.076C546.001 654.281 1030.16 405.529 1374.8 112.454C1337.94 13.1788 1284.57 -91.5233 1216.05 -198.713C842.017 119.464 316.697 389.473 42.6172 404.398Z",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M116.562 505.482C388.155 490.557 908.726 223.035 1279.37 -92.4277",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M200.234 593.676C464.59 579.203 971.593 318.692 1332.51 11.5957",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M385.441 312.135C453.961 419.324 529.492 510.458 609.545 583.275",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M806.514 95.7197C875.034 202.909 939.483 299.923 997.601 383.82",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M1216.05 -198.713C1284.57 -91.5233 1338.17 13.1787 1374.8 112.454C1719.44 -180.622 1794.06 -407.213 1541.69 -393.418C1514.33 -521.412 1465.71 -640.587 1397.19 -747.777C1671.04 -762.476 1589.86 -516.664 1216.05 -198.713Z",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M1332.51 11.5954C1693.43 -295.274 1771.67 -532.494 1507.09 -518.021",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M1541.46 -393.192C1567.92 -269.721 1573.35 -143.083 1557.97 -17.3502C1364.17 -6.72171 992.853 184.139 728.271 409.147C636.006 338.818 546.003 255.825 460.297 162.656C805.158 -130.646 1289.09 -379.398 1541.46 -393.192Z",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M1560.91 -268.816C1324.15 -255.927 870.511 -22.5516 547.359 252.207",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M1566.57 -143.31C1349.47 -131.55 933.378 82.3766 636.91 334.521",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M1225.55 -308.163C1269.2 -189.214 1299.5 -69.3609 1315.33 47.7789",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M837.723 -108.711C902.624 -0.616761 963.229 103.407 1017.73 200.873",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M460.52 162.431C546 255.6 636.229 338.593 728.494 408.922C463.912 633.929 406.472 807.83 600.273 797.201C491.501 777.301 388.155 733.883 293.629 668.302C41.2588 682.097 115.885 455.732 460.52 162.431Z",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M547.357 252.208C224.205 526.966 154.328 739.31 391.095 726.42",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M636.905 334.521C340.664 586.666 276.44 781.371 493.533 769.386",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M207.922 427.013C307.197 505.709 417.1 567.897 534.466 611.994",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M148.221 608.376C250.888 677.122 365.314 725.289 488.785 751.295",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M293.631 668.302C388.157 733.882 491.502 777.3 600.275 797.201C794.075 786.572 1165.39 595.711 1429.98 370.703C1428.85 295.399 1410.3 208.336 1374.8 112.453C1030.16 405.755 546.227 654.507 293.631 668.302Z",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M391.096 726.42C627.863 713.53 1081.5 480.156 1404.65 205.397",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M493.539 769.386C710.632 757.627 1126.73 543.7 1423.19 291.556",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M609.545 583.273C686.884 653.376 765.354 703.579 842.694 732.073",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M997.371 383.819C1053.45 465.003 1101.62 530.583 1140.29 578.977",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M1374.8 112.681C1410.3 208.564 1428.84 295.401 1429.97 370.931C1694.33 145.924 1751.77 -27.7507 1557.97 -17.1222C1573.57 -142.855 1567.92 -269.493 1541.46 -392.964C1794.06 -406.985 1719.43 -180.62 1374.8 112.681Z",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M1404.64 205.398C1727.8 -69.3598 1797.67 -281.704 1560.91 -268.814",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M1422.97 291.557C1719.43 39.6383 1783.66 -155.067 1566.56 -143.308",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M1557.97 -17.3486C1542.37 108.384 1506.64 227.333 1451.69 335.88C1344.95 341.759 1140.52 446.914 994.889 570.611C910.313 533.751 820.536 479.477 728.271 409.148C992.853 184.141 1364.17 -6.72013 1557.97 -17.3486Z",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M1535.81 105.896C1368.47 114.942 1048.03 279.797 819.633 474.05",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M1500.31 223.941C1362.14 231.404 1097.33 367.539 908.732 528.098",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M1315.55 47.7783C1331.61 165.144 1332.51 274.143 1318.26 371.609",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M1017.95 200.875C1072.68 298.341 1118.58 384.273 1154.31 455.959",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M728.269 409.147C820.534 479.477 910.311 533.976 994.887 570.61C849.253 694.534 817.82 790.191 924.331 784.311C818.046 812.805 709.048 817.327 600.275 797.201C406.474 807.83 463.914 633.929 728.269 409.147Z",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M819.63 474.05C591.456 668.303 541.932 818.233 709.048 809.187",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M908.727 528.096C720.128 688.428 679.423 812.352 817.367 804.889",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M534.469 611.994C651.835 656.091 770.783 679.836 888.149 682.323",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M488.564 751.295C612.036 777.301 737.995 779.788 862.824 758.984",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M600.273 797.201C709.046 817.328 818.271 812.805 924.33 784.311C1031.07 778.432 1235.5 673.277 1381.13 549.58C1414.6 506.387 1431.11 446.234 1429.98 370.704C1165.62 595.712 794.074 786.573 600.273 797.201Z",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M709.045 809.186C876.387 800.14 1196.83 635.285 1425.23 441.032",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M817.367 804.89C955.538 797.427 1220.35 661.292 1408.95 500.733",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M842.697 731.848C920.037 760.341 992.401 765.768 1057.75 748.356",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M1140.29 578.977C1178.96 627.37 1206.33 656.09 1221.7 664.231",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M1429.97 370.703C1431.11 446.008 1414.6 506.16 1381.13 549.579C1526.76 425.655 1558.2 329.999 1451.68 335.878C1506.64 227.332 1542.59 108.383 1557.97 -17.3501C1751.77 -27.9786 1694.33 145.922 1429.97 370.703Z",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M1425.23 441.032C1653.4 246.779 1702.92 96.849 1535.81 105.895",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M1408.95 500.733C1597.54 340.4 1638.25 216.477 1500.31 223.939",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M1451.69 335.88C1395.83 446.009 1322.56 540.535 1233.24 616.744C1230.98 616.97 1226.45 619.231 1223.29 621.945C1157.71 625.563 1080.82 607.924 995.113 570.838C1140.52 446.688 1344.95 341.759 1451.69 335.88Z",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M1390.18 440.582C1317.13 444.653 1177.38 516.565 1077.88 601.14",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M1317.13 534.429C1278.92 536.464 1205.87 574.003 1153.86 618.326",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M1318.26 371.835C1303.79 470.657 1274.39 553.65 1230.3 617.421",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M1154.32 455.959C1190.72 528.776 1215.15 583.953 1226.68 619.231",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M994.886 570.611C1080.59 607.924 1157.71 625.337 1223.06 621.719C1219.89 624.432 1219.22 626.468 1221.48 626.468C1132.15 702.45 1031.97 755.366 924.331 784.312C817.82 790.192 849.253 694.535 994.886 570.611Z",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M1077.65 601.14C978.149 685.942 956.44 751.296 1029.48 747.225",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M1153.86 618.325C1101.85 662.648 1090.54 696.795 1128.76 694.76",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M888.375 682.325C1007.32 685.038 1119.26 665.59 1221.02 624.207",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M863.049 758.985C989.686 737.728 1110.22 693.405 1220.35 626.016",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M924.555 784.311C1032.2 755.366 1132.38 702.449 1221.7 626.467C1223.96 626.241 1228.48 623.979 1231.65 621.266C1297.23 617.647 1347.21 593.224 1381.13 549.354C1235.5 673.277 1031.07 778.432 924.555 784.311Z",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M1029.48 747.45C1102.53 743.379 1242.28 671.467 1341.78 586.892",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M1128.76 694.761C1166.98 692.725 1240.02 655.186 1292.03 610.863",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M1057.98 748.355C1124.24 730.49 1180.54 689.559 1224.64 625.788",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M1221.7 664.232C1237.08 672.599 1239.57 659.257 1228.03 623.979",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M1381.13 549.579C1347.21 593.45 1297.01 617.873 1231.65 621.491C1234.82 618.777 1235.5 616.742 1233.24 616.742C1322.56 540.76 1395.83 446.008 1451.69 335.878C1558.2 329.999 1526.76 425.655 1381.13 549.579Z",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M1341.78 586.894C1441.28 502.092 1462.99 436.738 1389.95 440.808",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M1292.03 610.864C1344.04 566.541 1355.35 532.394 1317.13 534.429",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M1487.87 437.867C1420.93 516.337 1335.67 577.395 1234.14 619.004",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M1513.2 361.205C1438.34 463.42 1344.95 549.805 1234.59 617.194",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M1233.23 616.742C1231.2 618.325 1229.39 619.908 1227.36 621.717C1226 621.717 1224.64 621.943 1223.06 621.943C1226.45 619.004 1230.97 616.742 1233.23 616.742Z",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M1230.3 617.42C1229.39 618.777 1228.49 620.134 1227.36 621.49",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M1226.68 619.229C1226.9 619.907 1227.13 620.811 1227.35 621.49",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M1223.06 621.717C1224.42 621.717 1225.77 621.491 1227.36 621.491C1225.55 623.074 1223.51 624.883 1221.48 626.466C1219.21 626.692 1219.89 624.431 1223.06 621.717Z",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M1220.8 624.205C1223.06 623.3 1225.1 622.396 1227.36 621.491",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M1220.35 626.013C1222.84 624.657 1225.1 623.074 1227.58 621.717",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M1221.7 626.466C1223.74 624.883 1225.55 623.074 1227.58 621.491C1228.94 621.491 1230.52 621.265 1231.88 621.265C1228.49 623.978 1223.96 626.466 1221.7 626.466Z",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M1224.64 625.788C1225.55 624.431 1226.45 623.075 1227.58 621.718",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M1228.26 623.752C1228.03 623.073 1227.81 622.169 1227.58 621.49",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M1231.65 621.265C1230.3 621.265 1228.71 621.492 1227.36 621.492C1229.39 619.909 1231.2 618.326 1233.24 616.517C1235.5 616.517 1234.82 618.552 1231.65 621.265Z",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M1233.92 618.778C1231.65 619.683 1229.62 620.587 1227.36 621.492",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M1234.59 617.194C1232.11 618.551 1229.84 620.134 1227.36 621.491",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M83.7763 -919.191C94.4048 -928.237 108.878 -939.77 119.958 -948.363C127.873 -954.695 138.728 -962.61 146.869 -968.49C156.593 -975.5 165.638 -982.058 183.051 -993.365C199.333 -1003.99 211.545 -1011.46 219.007 -1015.75C223.304 -1018.24 238.455 -1027.29 256.32 -1036.78C262.652 -1040.18 271.019 -1044.47 277.351 -1047.64C283.23 -1050.58 291.145 -1054.42 297.025 -1057.36C304.487 -1060.98 314.664 -1065.73 322.352 -1069.12C335.016 -1074.55 351.75 -1081.56 364.414 -1086.53C374.364 -1090.6 387.706 -1095.35 397.883 -1098.75C411.225 -1103.27 429.316 -1109.15 442.884 -1113.22C450.573 -1115.48 460.523 -1118.19 468.212 -1120.23C474.77 -1122.04 483.589 -1124.07 490.373 -1125.88C498.74 -1127.92 510.047 -1130.4 518.414 -1132.21C526.103 -1133.8 536.732 -1136.06 544.42 -1137.19C550.752 -1138.32 559.345 -1139.9 565.903 -1140.81C573.366 -1141.94 583.09 -1143.29 590.553 -1144.43C626.056 -1149.17 650.705 -1150.53 665.404 -1151.44C723.07 -1154.6 781.187 -1150.76 839.079 -1140.13C947.851 -1120.23 1051.2 -1076.81 1145.72 -1011.23C1243.64 -943.388 1328.22 -854.742 1396.74 -747.552C1465.26 -640.363 1514.1 -521.188 1541.24 -393.193C1567.7 -269.722 1573.12 -143.084 1557.75 -17.3512C1542.14 108.382 1506.41 227.33 1451.46 335.877C1395.61 446.006 1322.34 540.532 1233.01 616.741C1230.75 616.967 1226.23 619.228 1223.06 621.942C1219.9 624.656 1219.22 626.691 1221.48 626.691C1223.74 626.691 1228.26 624.203 1231.43 621.49C1234.59 618.776 1235.27 616.741 1233.01 616.741C1322.34 540.758 1395.61 446.006 1451.46 335.877C1506.41 227.33 1542.37 108.382 1557.75 -17.3512C1573.35 -143.084 1567.7 -269.722 1541.24 -393.193C1513.88 -521.188 1465.26 -640.363 1396.74 -747.552C1328.22 -854.742 1243.64 -943.388 1145.72 -1011.23C1051.2 -1076.81 947.851 -1120.23 839.079 -1140.13C781.187 -1150.76 723.07 -1154.6 665.404 -1151.44C678.068 -1151.89 695.029 -1152.57 707.692 -1152.79C714.25 -1153.02 723.07 -1153.02 729.854 -1152.79C757.669 -1152.11 757.669 -1152.11 772.368 -1151.44C789.554 -1150.53 797.469 -1149.85 814.43 -1148.27C832.068 -1146.69 859.883 -1143.07 876.165 -1140.35C886.342 -1138.55 899.91 -1136.28 910.086 -1134.25C917.549 -1132.67 936.771 -1128.82 950.113 -1125.43C956.218 -1123.85 964.133 -1122.04 970.013 -1120.45C975.893 -1118.87 983.581 -1116.84 989.461 -1115.25C995.34 -1113.67 1003.26 -1111.41 1009.13 -1109.37C1034.01 -1101.46 1034.46 -1101.23 1047.35 -1096.71C1068.38 -1089.25 1084.67 -1082.69 1084.89 -1082.69C1105.92 -1074.1 1108.64 -1072.97 1121.75 -1067.09C1132.61 -1062.11 1146.85 -1055.33 1157.71 -1050.13C1169.47 -1044.25 1181.45 -1037.91 1193.21 -1031.58C1203.61 -1025.93 1217.41 -1017.79 1227.58 -1011.68C1227.81 -1011.68 1243.41 -1002.18 1261.28 -990.425C1271.46 -983.641 1285.02 -974.369 1294.97 -967.133C1297.24 -965.55 1318.04 -950.625 1343.59 -929.594C1368.92 -908.563 1389.5 -889.341 1389.73 -889.115C1409.17 -870.572 1409.17 -870.572 1418.9 -860.621C1427.49 -852.028 1438.57 -840.043 1446.71 -830.997C1478.37 -795.946 1508 -757.955 1534.68 -718.154C1542.6 -706.395 1549.61 -695.54 1556.84 -683.555C1564.08 -671.796 1564.08 -671.796 1577.65 -648.051C1582.85 -639.006 1595.06 -616.166 1605.91 -593.552C1608.63 -587.899 1614.96 -574.556 1622.65 -556.465C1627.4 -545.158 1633.5 -530.233 1637.8 -518.7C1637.8 -518.474 1647.98 -492.016 1657.7 -460.809C1660.41 -451.537 1664.26 -438.873 1669.01 -421.461C1672.4 -408.118 1672.4 -408.118 1678.5 -381.66C1681.9 -366.735 1687.32 -337.563 1689.81 -320.829C1691.62 -309.07 1693.66 -293.24 1695.01 -281.481C1696.6 -268.139 1697.73 -254.797 1698.63 -241.681C1699.54 -228.565 1700.21 -214.996 1700.67 -201.88C1701.12 -189.895 1701.12 -174.065 1701.12 -162.08C1701.12 -161.854 1701.12 -144.441 1699.99 -122.053C1699.31 -108.485 1699.31 -107.807 1697.05 -82.0268C1696.6 -75.9211 1695.69 -67.7801 1695.01 -61.9005C1694.33 -56.0209 1693.2 -47.88 1692.53 -42.0004C1691.85 -35.8946 1690.49 -27.7536 1689.59 -21.874C1689.13 -18.0297 1683.93 16.1172 1673.76 58.4051C1667.42 84.411 1661.32 105.442 1657.25 118.558C1655.21 125.342 1650.69 139.589 1644.13 158.132C1640.06 169.891 1633.96 185.269 1629.43 196.802C1627.17 202.908 1623.78 210.822 1621.07 216.702C1618.58 222.355 1615.19 230.044 1612.7 235.698C1609.98 241.803 1606.14 249.718 1603.43 255.598C1597.77 267.583 1597.55 268.035 1583.75 294.267C1580.59 300.373 1576.06 308.288 1572.67 314.168C1566.34 325.474 1557.29 339.947 1550.51 351.028C1546.67 357.134 1541.46 365.275 1537.39 371.154C1533.32 377.26 1527.67 385.401 1523.6 391.507C1519.76 396.934 1514.55 404.171 1510.48 409.598C1505.96 415.93 1499.4 424.297 1494.65 430.629C1471.14 460.931 1452.14 481.736 1446.03 488.52C1421.84 514.979 1401.49 534.426 1399.22 536.688C1388.82 546.412 1375.03 559.075 1364.4 568.573C1356.48 575.584 1345.85 584.403 1337.71 590.961C1329.8 597.519 1318.94 605.886 1310.58 612.218C1299.95 620.133 1285.7 630.309 1275.07 637.772C1273.72 638.676 1251.1 654.506 1220.57 672.597C1195.93 687.296 1175.12 698.151 1162 704.709C1150.02 710.588 1134.19 718.277 1121.98 723.704C1114.29 727.096 1104.11 731.619 1096.42 734.785C1086.47 738.856 1072.91 744.283 1062.73 748.127C1049.84 752.876 1032.65 758.756 1019.76 763.052C1006.87 767.349 982.903 774.359 958.48 780.465C942.876 784.309 918.001 790.189 888.603 795.164C856.491 800.817 828.676 803.757 818.274 804.888C805.384 806.245 788.424 807.375 775.534 808.28C768.75 808.732 759.704 809.185 752.92 809.185C741.839 809.411 727.366 809.863 716.286 809.637C704.752 809.637 688.244 809.185 673.772 808.506C661.334 807.828 644.826 806.697 632.388 805.566C626.056 805.114 617.689 804.21 611.357 803.531C584.221 800.139 584.221 800.139 569.974 798.104C550.3 795.164 536.505 792.45 529.269 790.867C496.705 784.535 469.116 777.073 469.116 777.073C444.467 770.289 443.336 770.063 429.994 765.992C409.642 759.66 393.586 754.007 391.777 753.328C376.852 748.127 352.203 739.082 317.603 723.704C305.618 718.277 293.407 712.624 281.647 706.744C269.436 700.638 268.079 699.96 246.37 688.201C246.144 688.201 230.992 679.833 211.771 668.3C201.594 662.195 188.252 653.601 178.302 647.043C173.101 643.651 166.317 639.129 161.116 635.51C156.141 631.892 149.356 627.369 144.381 623.751C139.406 620.133 132.848 615.158 127.873 611.54C114.983 602.042 93.7264 584.855 79.932 573.096C66.8159 561.789 47.1419 544.603 20.4575 517.466C16.1609 513.169 10.5074 507.29 6.21081 502.767C-12.5587 482.415 -14.5939 480.379 -21.1519 472.464C-38.7907 451.66 -38.7907 451.66 -47.1579 441.031C-55.9773 429.951 -55.9773 429.95 -72.0331 408.467C-81.3048 396.03 -97.5867 372.285 -106.858 357.586C-115.678 343.566 -130.377 320.273 -148.242 286.805C-154.8 274.593 -160.679 262.608 -166.785 250.17C-171.986 239.09 -178.544 224.164 -183.519 213.084C-186.007 207.43 -189.173 199.968 -191.434 194.088C-193.696 188.435 -196.635 180.746 -198.897 175.092C-201.158 169.439 -203.872 161.75 -205.907 155.871C-210.43 143.433 -214.726 130.317 -218.797 117.201C-220.606 111.321 -222.867 103.407 -224.677 97.527C-226.26 91.6474 -228.521 83.7325 -230.104 77.8529C-231.687 71.9733 -233.722 64.0585 -235.079 57.9528C-237.793 45.9674 -241.411 30.1377 -243.898 17.9262C-250.004 -13.2809 -258.145 -63.0312 -261.085 -121.827C-261.537 -129.29 -262.668 -151.904 -262.216 -181.754C-261.989 -193.739 -261.537 -209.569 -261.085 -221.554C-260.859 -227.66 -260.18 -235.575 -259.728 -241.681C-259.276 -247.786 -258.597 -255.701 -258.145 -261.807C-257.014 -273.792 -255.205 -289.622 -253.622 -301.607C-252.718 -308.844 -249.552 -329.422 -247.29 -342.086C-245.029 -354.071 -241.863 -369.901 -239.376 -381.886C-238.019 -387.992 -236.21 -396.133 -234.627 -402.239C-233.27 -408.345 -231.235 -416.486 -229.425 -422.365C-226.26 -434.124 -221.737 -449.954 -218.119 -461.713C-214.726 -473.246 -201.61 -514.404 -181.936 -560.536C-179.449 -566.415 -175.831 -574.556 -173.117 -580.436C-167.69 -591.743 -160.453 -606.894 -154.8 -618.201C-152.538 -622.724 -142.814 -641.493 -133.317 -658.001C-125.402 -671.796 -104.371 -708.656 -71.3547 -753.658C-61.4046 -767.226 -51.2284 -780.342 -41.2783 -792.554C-21.3781 -816.977 -8.0359 -831.223 -6.67907 -832.806C-1.93016 -838.008 4.62784 -845.018 9.60289 -850.219C18.6484 -859.491 30.8599 -871.702 40.1316 -880.748C57.3181 -896.351 77.4444 -913.99 83.7763 -919.191Z",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M83.7763 -919.191C94.4048 -928.237 108.878 -939.77 119.958 -948.363C127.873 -954.695 138.728 -962.61 146.869 -968.49C156.593 -975.5 165.638 -982.058 183.051 -993.365C199.333 -1003.99 211.545 -1011.46 219.007 -1015.75C223.304 -1018.24 238.455 -1027.29 256.32 -1036.78C262.652 -1040.18 271.019 -1044.47 277.351 -1047.64C283.23 -1050.58 291.145 -1054.42 297.025 -1057.36C304.487 -1060.98 314.664 -1065.73 322.352 -1069.12C335.016 -1074.55 351.75 -1081.56 364.414 -1086.53C374.364 -1090.6 387.706 -1095.35 397.883 -1098.75C411.225 -1103.27 429.316 -1109.15 442.884 -1113.22C450.573 -1115.48 460.523 -1118.19 468.212 -1120.23C474.77 -1122.04 483.589 -1124.07 490.373 -1125.88C498.74 -1127.92 510.047 -1130.4 518.414 -1132.21C526.103 -1133.8 536.732 -1136.06 544.42 -1137.19C550.752 -1138.32 559.345 -1139.9 565.903 -1140.81C573.366 -1141.94 583.09 -1143.29 590.553 -1144.43C626.056 -1149.17 650.705 -1150.53 665.404 -1151.44C723.07 -1154.6 781.187 -1150.76 839.079 -1140.13C947.851 -1120.23 1051.2 -1076.81 1145.72 -1011.23C1243.64 -943.388 1328.22 -854.742 1396.74 -747.552C1465.26 -640.363 1514.1 -521.188 1541.24 -393.193C1567.7 -269.722 1573.12 -143.084 1557.75 -17.3512C1542.14 108.382 1506.41 227.33 1451.46 335.877C1395.61 446.006 1322.34 540.532 1233.01 616.741C1230.75 616.967 1226.23 619.228 1223.06 621.942C1219.9 624.656 1219.22 626.691 1221.48 626.691C1223.74 626.691 1228.26 624.203 1231.43 621.49C1234.59 618.776 1235.27 616.741 1233.01 616.741C1322.34 540.758 1395.61 446.006 1451.46 335.877C1506.41 227.33 1542.37 108.382 1557.75 -17.3512C1573.35 -143.084 1567.7 -269.722 1541.24 -393.193C1513.88 -521.188 1465.26 -640.363 1396.74 -747.552C1328.22 -854.742 1243.64 -943.388 1145.72 -1011.23C1051.2 -1076.81 947.851 -1120.23 839.079 -1140.13C781.187 -1150.76 723.07 -1154.6 665.404 -1151.44C678.068 -1151.89 695.029 -1152.57 707.692 -1152.79C714.25 -1153.02 723.07 -1153.02 729.854 -1152.79C757.669 -1152.11 757.669 -1152.11 772.368 -1151.44C789.554 -1150.53 797.469 -1149.85 814.43 -1148.27C832.068 -1146.69 859.883 -1143.07 876.165 -1140.35C886.342 -1138.55 899.91 -1136.28 910.086 -1134.25C917.549 -1132.67 936.771 -1128.82 950.113 -1125.43C956.218 -1123.85 964.133 -1122.04 970.013 -1120.45C975.893 -1118.87 983.581 -1116.84 989.461 -1115.25C995.34 -1113.67 1003.26 -1111.41 1009.13 -1109.37C1034.01 -1101.46 1034.46 -1101.23 1047.35 -1096.71C1068.38 -1089.25 1084.67 -1082.69 1084.89 -1082.69C1105.92 -1074.1 1108.64 -1072.97 1121.75 -1067.09C1132.61 -1062.11 1146.85 -1055.33 1157.71 -1050.13C1169.47 -1044.25 1181.45 -1037.91 1193.21 -1031.58C1203.61 -1025.93 1217.41 -1017.79 1227.58 -1011.68C1227.81 -1011.68 1243.41 -1002.18 1261.28 -990.425C1271.46 -983.641 1285.02 -974.369 1294.97 -967.133C1297.24 -965.55 1318.04 -950.625 1343.59 -929.594C1368.92 -908.563 1389.5 -889.341 1389.73 -889.115C1409.17 -870.572 1409.17 -870.572 1418.9 -860.621C1427.49 -852.028 1438.57 -840.043 1446.71 -830.997C1478.37 -795.946 1508 -757.955 1534.68 -718.154C1542.6 -706.395 1549.61 -695.54 1556.84 -683.555C1564.08 -671.796 1564.08 -671.796 1577.65 -648.051C1582.85 -639.006 1595.06 -616.166 1605.91 -593.552C1608.63 -587.899 1614.96 -574.556 1622.65 -556.465C1627.4 -545.158 1633.5 -530.233 1637.8 -518.7C1637.8 -518.474 1647.98 -492.016 1657.7 -460.809C1660.41 -451.537 1664.26 -438.873 1669.01 -421.461C1672.4 -408.118 1672.4 -408.118 1678.5 -381.66C1681.9 -366.735 1687.32 -337.563 1689.81 -320.829C1691.62 -309.07 1693.66 -293.24 1695.01 -281.481C1696.6 -268.139 1697.73 -254.797 1698.63 -241.681C1699.54 -228.565 1700.21 -214.996 1700.67 -201.88C1701.12 -189.895 1701.12 -174.065 1701.12 -162.08C1701.12 -161.854 1701.12 -144.441 1699.99 -122.053C1699.31 -108.485 1699.31 -107.807 1697.05 -82.0268C1696.6 -75.9211 1695.69 -67.7801 1695.01 -61.9005C1694.33 -56.0209 1693.2 -47.88 1692.53 -42.0004C1691.85 -35.8946 1690.49 -27.7536 1689.59 -21.874C1689.13 -18.0297 1683.93 16.1172 1673.76 58.4051C1667.42 84.411 1661.32 105.442 1657.25 118.558C1655.21 125.342 1650.69 139.589 1644.13 158.132C1640.06 169.891 1633.96 185.269 1629.43 196.802C1627.17 202.908 1623.78 210.822 1621.07 216.702C1618.58 222.355 1615.19 230.044 1612.7 235.698C1609.98 241.803 1606.14 249.718 1603.43 255.598C1597.77 267.583 1597.55 268.035 1583.75 294.267C1580.59 300.373 1576.06 308.288 1572.67 314.168C1566.34 325.474 1557.29 339.947 1550.51 351.028C1546.67 357.134 1541.46 365.275 1537.39 371.154C1533.32 377.26 1527.67 385.401 1523.6 391.507C1519.76 396.934 1514.55 404.171 1510.48 409.598C1505.96 415.93 1499.4 424.297 1494.65 430.629C1471.14 460.931 1452.14 481.736 1446.03 488.52C1421.84 514.979 1401.49 534.426 1399.22 536.688C1388.82 546.412 1375.03 559.075 1364.4 568.573C1356.48 575.584 1345.85 584.403 1337.71 590.961C1329.8 597.519 1318.94 605.886 1310.58 612.218C1299.95 620.133 1285.7 630.309 1275.07 637.772C1273.72 638.676 1251.1 654.506 1220.57 672.597C1195.93 687.296 1175.12 698.151 1162 704.709C1150.02 710.588 1134.19 718.277 1121.98 723.704C1114.29 727.096 1104.11 731.619 1096.42 734.785C1086.47 738.856 1072.91 744.283 1062.73 748.127C1049.84 752.876 1032.65 758.756 1019.76 763.052C1006.87 767.349 982.903 774.359 958.48 780.465C942.876 784.309 918.001 790.189 888.603 795.164C856.491 800.817 828.676 803.757 818.274 804.888C805.384 806.245 788.424 807.375 775.534 808.28C768.75 808.732 759.704 809.185 752.92 809.185C741.839 809.411 727.366 809.863 716.286 809.637C704.752 809.637 688.244 809.185 673.772 808.506C661.334 807.828 644.826 806.697 632.388 805.566C626.056 805.114 617.689 804.21 611.357 803.531C584.221 800.139 584.221 800.139 569.974 798.104C550.3 795.164 536.505 792.45 529.269 790.867C496.705 784.535 469.116 777.073 469.116 777.073C444.467 770.289 443.336 770.063 429.994 765.992C409.642 759.66 393.586 754.007 391.777 753.328C376.852 748.127 352.203 739.082 317.603 723.704C305.618 718.277 293.407 712.624 281.647 706.744C269.436 700.638 268.079 699.96 246.37 688.201C246.144 688.201 230.992 679.833 211.771 668.3C201.594 662.195 188.252 653.601 178.302 647.043C173.101 643.651 166.317 639.129 161.116 635.51C156.141 631.892 149.356 627.369 144.381 623.751C139.406 620.133 132.848 615.158 127.873 611.54C114.983 602.042 93.7264 584.855 79.932 573.096C66.8159 561.789 47.1419 544.603 20.4575 517.466C16.1609 513.169 10.5074 507.29 6.21081 502.767C-12.5587 482.415 -14.5939 480.379 -21.1519 472.464C-38.7907 451.66 -38.7907 451.66 -47.1579 441.031C-55.9773 429.951 -55.9773 429.95 -72.0331 408.467C-81.3048 396.03 -97.5867 372.285 -106.858 357.586C-115.678 343.566 -130.377 320.273 -148.242 286.805C-154.8 274.593 -160.679 262.608 -166.785 250.17C-171.986 239.09 -178.544 224.164 -183.519 213.084C-186.007 207.43 -189.173 199.968 -191.434 194.088C-193.696 188.435 -196.635 180.746 -198.897 175.092C-201.158 169.439 -203.872 161.75 -205.907 155.871C-210.43 143.433 -214.726 130.317 -218.797 117.201C-220.606 111.321 -222.867 103.407 -224.677 97.527C-226.26 91.6474 -228.521 83.7325 -230.104 77.8529C-231.687 71.9733 -233.722 64.0585 -235.079 57.9528C-237.793 45.9674 -241.411 30.1377 -243.898 17.9262C-250.004 -13.2809 -258.145 -63.0312 -261.085 -121.827C-261.537 -129.29 -262.668 -151.904 -262.216 -181.754C-261.989 -193.739 -261.537 -209.569 -261.085 -221.554C-260.859 -227.66 -260.18 -235.575 -259.728 -241.681C-259.276 -247.786 -258.597 -255.701 -258.145 -261.807C-257.014 -273.792 -255.205 -289.622 -253.622 -301.607C-252.718 -308.844 -249.552 -329.422 -247.29 -342.086C-245.029 -354.071 -241.863 -369.901 -239.376 -381.886C-238.019 -387.992 -236.21 -396.133 -234.627 -402.239C-233.27 -408.345 -231.235 -416.486 -229.425 -422.365C-226.26 -434.124 -221.737 -449.954 -218.119 -461.713C-214.726 -473.246 -201.61 -514.404 -181.936 -560.536C-179.449 -566.415 -175.831 -574.556 -173.117 -580.436C-167.69 -591.743 -160.453 -606.894 -154.8 -618.201C-152.538 -622.724 -142.814 -641.493 -133.317 -658.001C-125.402 -671.796 -104.371 -708.656 -71.3547 -753.658C-61.4046 -767.226 -51.2284 -780.342 -41.2783 -792.554C-21.3781 -816.977 -8.0359 -831.223 -6.67907 -832.806C-1.93016 -838.008 4.62784 -845.018 9.60289 -850.219C18.6484 -859.491 30.8599 -871.702 40.1316 -880.748C57.3181 -896.351 77.4444 -913.99 83.7763 -919.191Z",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M1451.69 335.874C1395.83 446.003 1322.56 540.529 1233.24 616.738C1230.98 616.964 1226.45 619.225 1223.29 621.939C1157.71 625.557 1080.82 607.918 995.115 570.832C1140.52 446.682 1344.95 341.754 1451.69 335.874Z",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M1318.27 371.831C1303.79 470.654 1274.4 553.646 1230.3 617.417",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M1154.32 455.952C1190.73 528.769 1215.15 583.947 1226.68 619.224",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M994.886 570.607C1080.59 607.92 1157.71 625.333 1223.06 621.715C1219.89 624.428 1219.22 626.464 1221.48 626.464C1132.15 702.446 1031.97 755.363 924.331 784.308C817.82 790.188 849.253 694.531 994.886 570.607Z",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M888.375 682.321C1007.32 685.034 1119.26 665.586 1221.02 624.203",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M863.049 758.981C989.686 737.724 1110.22 693.401 1220.35 626.012",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M924.559 784.308C1032.2 755.362 1132.38 702.445 1221.7 626.463C1223.97 626.237 1228.49 623.975 1231.65 621.262C1297.23 617.643 1347.21 593.22 1381.13 549.35C1235.5 673.273 1031.07 778.428 924.559 784.308Z",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M1057.98 748.351C1124.24 730.486 1180.55 689.555 1224.64 625.784",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M1221.71 664.228C1237.08 672.595 1239.57 659.253 1228.04 623.976",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M1381.13 549.575C1347.21 593.446 1297.01 617.869 1231.65 621.487C1234.82 618.774 1235.5 616.738 1233.24 616.738C1322.56 540.756 1395.83 446.004 1451.69 335.874C1558.2 329.995 1526.76 425.651 1381.13 549.575Z",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M1487.87 437.863C1420.93 516.333 1335.68 577.391 1234.14 619",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M1513.2 361.201C1438.35 463.416 1344.95 549.801 1234.6 617.19",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M1233.23 616.738C1231.2 618.321 1229.39 619.904 1227.36 621.713C1226 621.713 1224.64 621.94 1223.06 621.94C1226.45 619 1230.97 616.738 1233.23 616.738Z",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M1231.2 618.321C1229.62 618.321 1226.68 619.904 1224.41 621.713",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M1229.39 619.905C1228.71 619.905 1227.13 620.81 1226 621.714",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M1230.3 617.416C1229.39 618.773 1228.49 620.13 1227.36 621.486",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M1226.68 619.228C1226.9 619.906 1227.13 620.811 1227.35 621.489",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M1223.06 621.714C1224.42 621.714 1225.77 621.488 1227.36 621.488C1225.55 623.071 1223.51 624.88 1221.48 626.463C1219.21 626.689 1219.89 624.428 1223.06 621.714Z",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M1224.64 621.714C1222.61 623.523 1222.16 624.88 1223.51 624.88",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M1226 621.714C1224.87 622.618 1224.64 623.297 1225.55 623.297",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M1220.8 624.202C1223.06 623.297 1225.1 622.393 1227.36 621.488",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M1220.35 626.011C1222.84 624.654 1225.1 623.071 1227.58 621.714",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M1221.7 626.463C1223.74 624.88 1225.55 623.071 1227.58 621.488C1228.94 621.488 1230.52 621.262 1231.88 621.262C1228.49 623.975 1223.96 626.463 1221.7 626.463Z",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M1223.51 624.881C1225.1 624.881 1228.04 623.298 1230.3 621.489",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M1225.54 623.298C1226.22 623.298 1227.81 622.394 1228.94 621.489",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M1224.64 625.785C1225.55 624.428 1226.45 623.072 1227.58 621.715",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M1228.26 623.751C1228.03 623.072 1227.81 622.168 1227.58 621.489",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M1231.65 621.263C1230.3 621.263 1228.71 621.489 1227.36 621.489C1229.39 619.906 1231.2 618.323 1233.24 616.514C1235.5 616.514 1234.82 618.549 1231.65 621.263Z",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M1230.3 621.488C1232.33 619.679 1232.79 618.322 1231.43 618.322",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M1228.71 621.488C1229.84 620.584 1230.07 619.905 1229.17 619.905",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M1233.92 618.775C1231.65 619.68 1229.62 620.585 1227.36 621.489",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M1234.59 617.191C1232.11 618.548 1229.84 620.131 1227.36 621.488",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M1233.24 616.738C1231.2 618.321 1229.4 619.904 1227.36 621.713C1229.4 619.904 1231.2 618.321 1233.24 616.738ZM1233.24 616.738C1235.5 616.512 1234.82 618.774 1231.66 621.487C1228.49 624.201 1223.97 626.462 1221.71 626.688C1219.45 626.915 1220.12 624.653 1223.29 621.94C1226.46 619 1230.98 616.738 1233.24 616.738Z",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M1233.24 616.738C1231.2 618.321 1229.4 619.904 1227.36 621.713C1229.4 619.904 1231.2 618.321 1233.24 616.738ZM1233.24 616.738C1235.5 616.512 1234.82 618.774 1231.66 621.487C1228.49 624.201 1223.97 626.462 1221.71 626.688C1219.45 626.915 1220.12 624.653 1223.29 621.94C1226.46 619 1230.98 616.738 1233.24 616.738Z",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M1227.36 621.49C1600.26 304.217 1676.02 -309.522 1396.06 -746.874C1122.43 -731.949 597.788 -462.166 224.207 -144.441C504.166 292.911 954.182 636.415 1227.36 621.49Z",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M1499.18 223.034C1361.23 230.497 1096.65 366.632 908.051 526.738",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M1559.55 -268.139C1323.24 -255.249 870.284 -22.3262 547.811 251.98",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M1227.36 621.489C1411.43 355.098 1333.64 -217.485 1053.68 -654.61",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M1227.36 621.49C1179.64 474.274 913.026 -1.29571 633.293 -438.647",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M1227.36 621.489C954.183 636.414 504.168 292.683 224.208 -144.442C-149.373 173.282 -230.33 418.869 43.5236 403.717C323.257 841.069 854.456 938.761 1227.36 621.489Z",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M908.053 526.736C719.679 687.068 678.748 810.766 816.919 803.304",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M548.038 251.753C225.565 526.059 155.688 737.951 392.003 725.061",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M1227.36 621.489C803.122 794.485 230.313 579.427 -49.4199 142.075",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M1227.36 621.489C767.393 903.032 165.413 776.168 -114.32 338.816",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M1227.36 621.488C854.454 938.76 323.255 841.069 43.5215 403.717C317.149 388.792 841.79 119.009 1215.37 -198.716C1495.33 238.636 1500.53 606.563 1227.36 621.488Z",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M816.914 803.303C954.859 795.841 1219.44 659.706 1408.04 499.6",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M392 725.06C628.315 712.17 1081.27 479.247 1403.74 204.941",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M1227.36 621.488C1043.28 887.879 665.856 748.804 385.896 311.679",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M1227.36 621.487C1275.07 768.703 1086.25 532.841 806.289 95.4893",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M1227.35 621.491C1500.53 606.565 1495.1 238.638 1215.37 -198.714C1588.95 -516.438 1669.91 -762.024 1396.05 -747.099C1676.01 -309.521 1600.26 304.218 1227.35 621.491Z",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M1407.81 499.376C1596.19 339.044 1637.12 215.346 1498.95 222.809",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M1403.51 205.17C1725.99 -69.1362 1795.86 -281.028 1559.55 -268.138",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M1227.36 621.491C1651.59 448.495 1768.96 -48.1048 1489 -485.23",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M1227.36 621.491C1687.32 339.949 1833.86 -244.619 1553.9 -681.971",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M224.208 -144.441C-55.751 -581.793 -60.9521 -949.72 211.545 -965.55C-160.679 -647.373 -236.436 -33.407 43.5238 403.719C-230.33 418.87 -149.372 173.284 224.208 -144.441Z",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M-49.4224 142.302C-329.382 -295.049 -212.016 -791.649 211.541 -965.55",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M-114.322 338.817C-394.282 -98.5349 -247.744 -683.329 211.543 -965.55",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M43.5238 403.718C-236.436 -33.408 -160.679 -647.374 211.545 -965.551C485.398 -979.571 935.414 -635.841 1215.37 -198.715C841.793 119.235 317.151 388.793 43.5238 403.718Z",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M385.896 311.678C105.937 -125.674 28.1451 -698.256 211.543 -965.552",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M806.289 95.4897C526.33 -341.862 259.939 -817.431 211.545 -965.552",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M774.628 806.922C754.954 807.826 728.722 808.957 709.048 808.279C677.841 807.374 636.232 804.887 605.024 801.494C562.51 796.972 506.428 785.213 465.045 774.584C437.682 767.574 402.178 755.815 375.72 746.091C342.93 733.879 290.014 712.17 229.408 677.345C198.201 659.253 150.034 629.403 96.8914 585.759C77.2173 569.477 51.6637 547.089 33.7987 528.998C0.782506 495.529 -41.0531 448.266 -69.0943 410.501C-94.8741 375.676 -126.986 327.282 -145.981 288.386C-157.288 265.094 -173.796 235.018 -182.842 210.821C-190.983 189.112 -202.968 160.166 -210.205 138.004C-218.12 114.034 -228.296 81.6958 -233.271 56.8206C-237.794 34.4329 -244.352 4.80884 -247.97 -17.805C-251.814 -42.9064 -256.111 -76.3749 -257.468 -101.702C-258.598 -124.09 -259.955 -153.714 -259.729 -176.102C-259.503 -201.882 -258.598 -236.255 -255.432 -261.808C-250.231 -304.549 -241.186 -361.535 -231.688 -403.597C-225.808 -428.699 -215.632 -461.715 -207.717 -486.138C-201.385 -505.36 -191.661 -530.235 -183.973 -549.004C-173.796 -574.106 -157.967 -606.217 -145.755 -630.414C-138.066 -645.791 -126.533 -665.466 -117.488 -680.165C-108.895 -694.637 -96.6832 -713.407 -87.1853 -727.201C-79.4966 -738.508 -68.642 -753.207 -60.501 -764.288C-46.9327 -782.605 -27.2586 -805.898 -12.1074 -823.084C-4.87094 -831.451 5.07915 -842.306 12.7679 -850.221C27.4669 -865.146 47.367 -884.594 62.5183 -899.067C69.3024 -905.398 78.348 -913.313 85.5844 -919.193C100.283 -931.404 110.912 -940.45 124.706 -950.852C140.084 -962.385 152.069 -971.431 160.889 -977.31C166.09 -980.929 173.1 -985.904 178.527 -989.296C183.729 -992.688 190.965 -997.437 196.166 -1000.83C201.593 -1004.22 208.604 -1008.52 214.031 -1011.91C214.257 -1011.91 230.313 -1021.86 251.344 -1033.17C256.545 -1035.88 271.923 -1044.25 292.501 -1054.2C334.337 -1074.32 366.901 -1086.54 367.353 -1086.54C386.349 -1093.55 411.902 -1102.37 431.124 -1108.47C444.014 -1112.54 461.427 -1117.29 474.543 -1120.68C489.92 -1124.53 510.499 -1129.28 525.876 -1132.44C541.932 -1135.61 563.415 -1139 579.471 -1141.49C604.798 -1145.33 638.945 -1148.04 664.499 -1149.85C505.976 -1141.26 348.357 -1080.88 211.77 -965.325C348.131 -1081.11 505.75 -1141.49 664.273 -1150.08C681.007 -1160.93 710.631 -1151.66 730.531 -1151.44C750.658 -1151.21 777.568 -1149.85 797.694 -1148.27C825.509 -1146.01 862.596 -1141.71 889.959 -1136.51C932.699 -1128.37 988.781 -1114.12 1030.16 -1101.01C1056.17 -1092.87 1090.09 -1079.3 1115.19 -1068.22C1138.71 -1057.82 1169.92 -1043.12 1192.31 -1030.23C1231.88 -1007.84 1282.54 -974.371 1319.17 -947.46C1339.75 -932.083 1365.75 -909.695 1384.52 -892.282C1403.29 -874.87 1427.72 -851.125 1444.68 -831.903C1476.11 -796.174 1514.78 -745.745 1541.46 -706.397C1556.16 -684.687 1573.58 -654.385 1585.79 -631.319C1599.36 -605.765 1616.32 -570.714 1626.94 -543.803C1643.9 -500.611 1662.67 -441.815 1673.98 -396.813C1680.09 -372.616 1685.97 -339.6 1689.58 -314.725C1699.31 -247.562 1700.21 -191.932 1699.76 -156.428C1699.31 -130.648 1697.5 -96.275 1694.56 -70.7214C1689.36 -27.9812 1679.41 28.5533 1669.23 70.3889C1663.13 95.4903 1652.72 128.507 1644.36 152.929C1638.02 171.925 1627.85 196.574 1620.16 215.118C1609.76 240.219 1593.25 272.331 1580.81 296.527C1573.12 311.453 1561.59 330.9 1552.54 345.147C1543.95 359.168 1531.74 377.485 1522.47 391.053C1513.87 403.265 1501.89 419.094 1493.07 430.854C1479.5 448.719 1460.05 471.332 1444.9 487.84C1430.66 503.67 1410.76 524.023 1395.38 538.722C1388.14 545.506 1378.42 554.777 1370.96 561.335C1360.33 570.607 1346.08 582.819 1335.23 591.638C1321.43 602.945 1294.97 622.845 1279.14 633.7C1264.67 643.65 1257.89 648.173 1243.64 657.218C1232.78 664.002 1218.31 672.822 1207.23 679.154C1186.43 691.139 1161.55 704.029 1146.85 711.039C1129.67 719.18 1106.37 730.261 1072 743.603C1036.72 757.171 1008.46 765.538 1005.29 766.443C980.64 773.679 947.172 782.273 922.071 787.7C903.527 791.771 878.426 796.067 859.656 798.555C834.103 801.947 800.182 805.565 774.628 806.922Z",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M774.628 806.922C754.954 807.826 728.722 808.957 709.048 808.279C677.841 807.374 636.232 804.887 605.024 801.494C562.51 796.972 506.428 785.213 465.045 774.584C437.682 767.574 402.178 755.815 375.72 746.091C342.93 733.879 290.014 712.17 229.408 677.345C198.201 659.253 150.034 629.403 96.8914 585.759C77.2173 569.477 51.6637 547.089 33.7987 528.998C0.782506 495.529 -41.0531 448.266 -69.0943 410.501C-94.8741 375.676 -126.986 327.282 -145.981 288.386C-157.288 265.094 -173.796 235.018 -182.842 210.821C-190.983 189.112 -202.968 160.166 -210.205 138.004C-218.12 114.034 -228.296 81.6958 -233.271 56.8206C-237.794 34.4329 -244.352 4.80884 -247.97 -17.805C-251.814 -42.9064 -256.111 -76.3749 -257.468 -101.702C-258.598 -124.09 -259.955 -153.714 -259.729 -176.102C-259.503 -201.882 -258.598 -236.255 -255.432 -261.808C-250.231 -304.549 -241.186 -361.535 -231.688 -403.597C-225.808 -428.699 -215.632 -461.715 -207.717 -486.138C-201.385 -505.36 -191.661 -530.235 -183.973 -549.004C-173.796 -574.106 -157.967 -606.217 -145.755 -630.414C-138.066 -645.791 -126.533 -665.466 -117.488 -680.165C-108.895 -694.637 -96.6832 -713.407 -87.1853 -727.201C-79.4966 -738.508 -68.642 -753.207 -60.501 -764.288C-46.9327 -782.605 -27.2586 -805.898 -12.1074 -823.084C-4.87094 -831.451 5.07915 -842.306 12.7679 -850.221C27.4669 -865.146 47.367 -884.594 62.5183 -899.067C69.3024 -905.398 78.348 -913.313 85.5844 -919.193C100.283 -931.404 110.912 -940.45 124.706 -950.852C140.084 -962.385 152.069 -971.431 160.889 -977.31C166.09 -980.929 173.1 -985.904 178.527 -989.296C183.729 -992.688 190.965 -997.437 196.166 -1000.83C201.593 -1004.22 208.604 -1008.52 214.031 -1011.91C214.257 -1011.91 230.313 -1021.86 251.344 -1033.17C256.545 -1035.88 271.923 -1044.25 292.501 -1054.2C334.337 -1074.32 366.901 -1086.54 367.353 -1086.54C386.349 -1093.55 411.902 -1102.37 431.124 -1108.47C444.014 -1112.54 461.427 -1117.29 474.543 -1120.68C489.92 -1124.53 510.499 -1129.28 525.876 -1132.44C541.932 -1135.61 563.415 -1139 579.471 -1141.49C604.798 -1145.33 638.945 -1148.04 664.499 -1149.85C505.976 -1141.26 348.357 -1080.88 211.77 -965.325C348.131 -1081.11 505.75 -1141.49 664.273 -1150.08C681.007 -1160.93 710.631 -1151.66 730.531 -1151.44C750.658 -1151.21 777.568 -1149.85 797.694 -1148.27C825.509 -1146.01 862.596 -1141.71 889.959 -1136.51C932.699 -1128.37 988.781 -1114.12 1030.16 -1101.01C1056.17 -1092.87 1090.09 -1079.3 1115.19 -1068.22C1138.71 -1057.82 1169.92 -1043.12 1192.31 -1030.23C1231.88 -1007.84 1282.54 -974.371 1319.17 -947.46C1339.75 -932.083 1365.75 -909.695 1384.52 -892.282C1403.29 -874.87 1427.72 -851.125 1444.68 -831.903C1476.11 -796.174 1514.78 -745.745 1541.46 -706.397C1556.16 -684.687 1573.58 -654.385 1585.79 -631.319C1599.36 -605.765 1616.32 -570.714 1626.94 -543.803C1643.9 -500.611 1662.67 -441.815 1673.98 -396.813C1680.09 -372.616 1685.97 -339.6 1689.58 -314.725C1699.31 -247.562 1700.21 -191.932 1699.76 -156.428C1699.31 -130.648 1697.5 -96.275 1694.56 -70.7214C1689.36 -27.9812 1679.41 28.5533 1669.23 70.3889C1663.13 95.4903 1652.72 128.507 1644.36 152.929C1638.02 171.925 1627.85 196.574 1620.16 215.118C1609.76 240.219 1593.25 272.331 1580.81 296.527C1573.12 311.453 1561.59 330.9 1552.54 345.147C1543.95 359.168 1531.74 377.485 1522.47 391.053C1513.87 403.265 1501.89 419.094 1493.07 430.854C1479.5 448.719 1460.05 471.332 1444.9 487.84C1430.66 503.67 1410.76 524.023 1395.38 538.722C1388.14 545.506 1378.42 554.777 1370.96 561.335C1360.33 570.607 1346.08 582.819 1335.23 591.638C1321.43 602.945 1294.97 622.845 1279.14 633.7C1264.67 643.65 1257.89 648.173 1243.64 657.218C1232.78 664.002 1218.31 672.822 1207.23 679.154C1186.43 691.139 1161.55 704.029 1146.85 711.039C1129.67 719.18 1106.37 730.261 1072 743.603C1036.72 757.171 1008.46 765.538 1005.29 766.443C980.64 773.679 947.172 782.273 922.071 787.7C903.527 791.771 878.426 796.067 859.656 798.555C834.103 801.947 800.182 805.565 774.628 806.922Z",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M1227.36 621.488C1600.26 304.215 1676.02 -309.524 1396.06 -746.876C1122.43 -731.951 597.788 -462.168 224.207 -144.443C504.166 292.909 954.182 636.413 1227.36 621.488Z",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M1499.18 223.033C1361.23 230.496 1096.65 366.631 908.051 526.737",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M1559.55 -268.141C1323.24 -255.251 870.284 -22.3281 547.811 251.978",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M1227.36 621.487C1411.43 355.096 1333.64 -217.487 1053.68 -654.612",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M1227.36 621.488C1179.64 474.272 913.026 -1.29767 633.293 -438.649",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M1227.36 621.487C954.183 636.412 504.168 292.681 224.208 -144.444C-149.373 173.28 -230.33 418.867 43.5236 403.715C323.257 841.067 854.456 938.759 1227.36 621.487Z",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M908.053 526.734C719.679 687.067 678.748 810.764 816.919 803.302",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M548.038 251.751C225.565 526.057 155.688 737.949 392.003 725.059",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M1227.36 621.487C803.122 794.483 230.313 579.425 -49.4199 142.073",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M1227.36 621.487C767.393 903.029 165.413 776.165 -114.32 338.813",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M1227.36 621.485C854.454 938.758 323.255 841.066 43.5215 403.714C317.149 388.789 841.79 119.006 1215.37 -198.719C1495.33 238.633 1500.53 606.56 1227.36 621.485Z",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M816.914 803.301C954.859 795.838 1219.44 659.703 1408.04 499.597",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M392 725.057C628.315 712.167 1081.27 479.244 1403.74 204.938",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M1227.36 621.485C1043.28 887.877 665.856 748.801 385.896 311.676",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M1227.36 621.484C1275.07 768.701 1086.25 532.838 806.289 95.4863",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M1227.35 621.488C1500.53 606.563 1495.1 238.635 1215.37 -198.716C1588.95 -516.441 1669.91 -762.027 1396.05 -747.102C1676.01 -309.524 1600.26 304.215 1227.35 621.488Z",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M1407.81 499.373C1596.19 339.041 1637.12 215.343 1498.95 222.806",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M1403.51 205.167C1725.99 -69.1392 1795.86 -281.031 1559.55 -268.141",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M1227.36 621.488C1651.59 448.492 1768.96 -48.1078 1489 -485.233",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M1227.36 621.488C1687.32 339.946 1833.86 -244.622 1553.9 -681.974",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M224.208 -144.444C-55.751 -581.796 -60.9521 -949.723 211.545 -965.553C-160.679 -647.376 -236.436 -33.41 43.5238 403.716C-230.33 418.867 -149.372 173.281 224.208 -144.444Z",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M-49.4224 142.299C-329.382 -295.052 -212.016 -791.652 211.541 -965.553",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M-114.322 338.814C-394.282 -98.5378 -247.744 -683.332 211.543 -965.553",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M43.5238 403.715C-236.436 -33.4109 -160.679 -647.377 211.545 -965.554C485.398 -979.574 935.414 -635.844 1215.37 -198.718C841.793 119.232 317.151 388.79 43.5238 403.715Z",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M385.896 311.677C105.937 -125.675 28.1451 -698.257 211.543 -965.553",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M806.289 95.4887C526.33 -341.863 259.939 -817.432 211.545 -965.553",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M-105.729 357.132C-120.202 335.423 -137.389 304.894 -149.374 281.602C-182.164 218.509 -201.838 164.236 -212.693 130.315C-234.854 62.0212 -244.804 5.26034 -249.553 -27.3036C-253.398 -53.3095 -257.242 -88.1348 -258.373 -114.367C-260.182 -158.69 -259.277 -218.164 -255.659 -262.261C-253.398 -289.398 -247.97 -325.128 -242.995 -351.812C-228.296 -430.056 -207.266 -489.304 -197.089 -516.893C-190.079 -535.663 -179.903 -560.312 -171.536 -578.403C-163.395 -596.268 -151.409 -619.786 -142.364 -637.199C-126.986 -667.275 -102.563 -705.493 -83.3416 -733.308C-70.6779 -751.851 -52.3607 -775.596 -38.1139 -793.008C-23.8672 -810.421 -3.96704 -832.583 11.1842 -848.865C25.431 -864.242 45.5573 -883.69 61.1608 -897.71C76.9905 -912.409 90.1066 -923.264 105.258 -935.702C112.72 -941.807 131.942 -956.733 142.797 -964.421C148.224 -968.266 155.234 -973.467 160.888 -977.311C171.516 -984.548 185.537 -993.819 196.165 -1000.83C207.246 -1007.84 210.186 -1009.65 232.348 -1022.54C238.001 -1025.93 245.69 -1030 251.569 -1033.17C272.6 -1044.47 286.169 -1051.48 315.114 -1064.6C329.813 -1071.38 354.01 -1081.33 369.84 -1087.44C388.835 -1094.68 414.615 -1103.27 434.063 -1109.38C448.536 -1114.12 468.21 -1119.33 483.135 -1122.94C504.166 -1127.92 532.207 -1133.8 553.464 -1137.64C586.028 -1143.52 630.804 -1147.37 664.272 -1150.08C939.709 -1165.01 1218.54 -1024.35 1396.06 -746.876C1676.02 -309.524 1600.26 304.215 1227.36 621.488C1600.26 304.215 1676.02 -309.524 1396.06 -746.876C1218.54 -1024.35 939.709 -1165.01 664.272 -1150.08C691.409 -1151.21 727.817 -1152.79 754.954 -1150.76C775.08 -1149.4 802.217 -1148.27 822.343 -1146.01C847.67 -1143.07 881.365 -1138.55 906.24 -1133.35C941.97 -1125.88 990.816 -1115.71 1056.62 -1091.74C1077.65 -1084.05 1105.24 -1072.97 1125.59 -1063.7C1148.43 -1053.29 1178.28 -1038.82 1199.99 -1026.16C1219.67 -1014.85 1245.67 -999.473 1264.44 -986.809C1285.25 -972.788 1312.61 -953.567 1331.83 -937.511C1367.56 -907.887 1412.79 -865.373 1444.68 -831.678C1462.31 -812.909 1484.02 -786.224 1499.63 -765.646C1514.1 -746.65 1532.19 -719.966 1545.53 -700.065C1561.82 -675.642 1581.49 -641.496 1594.15 -615.037C1604.33 -593.78 1618.12 -565.513 1626.94 -543.578C1636.67 -519.833 1648.2 -487.721 1655.89 -463.298C1676.47 -397.266 1685.97 -341.184 1690.94 -305.454C1700.44 -235.803 1700.44 -178.816 1699.53 -143.991C1698.63 -116.176 1696.14 -79.0893 1692.3 -51.5004C1686.42 -8.98634 1675.34 47.3221 1664.48 88.7055C1656.79 118.103 1643.68 156.321 1632.6 184.588C1625.36 203.132 1614.73 227.328 1606.59 245.42C1598 264.415 1585.11 289.064 1574.93 307.381C1566.79 322.08 1555.26 341.302 1546.21 355.549C1533.32 375.901 1515 402.133 1500.53 421.129C1486.96 438.994 1467.74 462.286 1452.82 479.021C1429.3 505.479 1404.42 530.806 1378.64 554.325C1359.65 571.511 1346.98 582.14 1334.55 592.09C1326.86 598.422 1307.41 613.347 1296.78 621.035C1281.63 631.89 1271.68 638.9 1261.05 645.911C1255.62 649.303 1248.61 654.052 1243.19 657.444C1237.76 660.836 1230.52 665.132 1225.1 668.525C1219.67 671.917 1212.21 676.213 1206.78 679.379C1195.25 685.937 1179.64 694.304 1167.88 700.41C1161.55 703.802 1152.73 708.099 1146.17 711.265C1142.78 712.848 1124.92 721.667 1098.01 732.974C1089.41 736.592 1077.88 741.115 1069.06 744.507C1059.79 748.125 1047.12 752.422 1037.63 755.814C1025.42 760.111 1009.13 765.312 996.696 768.93C984.484 772.322 967.976 777.071 955.765 780.011C934.734 784.76 906.692 791.092 885.662 794.71C852.419 800.137 807.87 805.112 774.402 807.147C743.647 808.956 702.263 809.861 671.509 807.374C645.503 805.338 610.677 803.755 585.124 799.233C564.093 795.614 535.825 791.318 515.021 787.021C490.145 781.82 457.355 773.679 433.159 765.99C391.097 752.422 336.145 730.26 295.44 712.622C272.374 702.445 242.75 685.937 221.041 673.047C199.558 660.384 170.838 642.971 151.164 627.82C114.53 599.778 66.362 561.561 33.3458 529.449C3.04324 499.825 -33.365 456.407 -60.2755 423.39C-75.2006 404.169 -92.3872 377.032 -105.729 357.132Z",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M-105.729 357.132C-120.202 335.423 -137.389 304.894 -149.374 281.602C-182.164 218.509 -201.838 164.236 -212.693 130.315C-234.854 62.0212 -244.804 5.26034 -249.553 -27.3036C-253.398 -53.3095 -257.242 -88.1348 -258.373 -114.367C-260.182 -158.69 -259.277 -218.164 -255.659 -262.261C-253.398 -289.398 -247.97 -325.128 -242.995 -351.812C-228.296 -430.056 -207.266 -489.304 -197.089 -516.893C-190.079 -535.663 -179.903 -560.312 -171.536 -578.403C-163.395 -596.268 -151.409 -619.786 -142.364 -637.199C-126.986 -667.275 -102.563 -705.493 -83.3416 -733.308C-70.6779 -751.851 -52.3607 -775.596 -38.1139 -793.008C-23.8672 -810.421 -3.96704 -832.583 11.1842 -848.865C25.431 -864.242 45.5573 -883.69 61.1608 -897.71C76.9905 -912.409 90.1066 -923.264 105.258 -935.702C112.72 -941.807 131.942 -956.733 142.797 -964.421C148.224 -968.266 155.234 -973.467 160.888 -977.311C171.516 -984.548 185.537 -993.819 196.165 -1000.83C207.246 -1007.84 210.186 -1009.65 232.348 -1022.54C238.001 -1025.93 245.69 -1030 251.569 -1033.17C272.6 -1044.47 286.169 -1051.48 315.114 -1064.6C329.813 -1071.38 354.01 -1081.33 369.84 -1087.44C388.835 -1094.68 414.615 -1103.27 434.063 -1109.38C448.536 -1114.12 468.21 -1119.33 483.135 -1122.94C504.166 -1127.92 532.207 -1133.8 553.464 -1137.64C586.028 -1143.52 630.804 -1147.37 664.272 -1150.08C939.709 -1165.01 1218.54 -1024.35 1396.06 -746.876C1676.02 -309.524 1600.26 304.215 1227.36 621.488C1600.26 304.215 1676.02 -309.524 1396.06 -746.876C1218.54 -1024.35 939.709 -1165.01 664.272 -1150.08C691.409 -1151.21 727.817 -1152.79 754.954 -1150.76C775.08 -1149.4 802.217 -1148.27 822.343 -1146.01C847.67 -1143.07 881.365 -1138.55 906.24 -1133.35C941.97 -1125.88 990.816 -1115.71 1056.62 -1091.74C1077.65 -1084.05 1105.24 -1072.97 1125.59 -1063.7C1148.43 -1053.29 1178.28 -1038.82 1199.99 -1026.16C1219.67 -1014.85 1245.67 -999.473 1264.44 -986.809C1285.25 -972.788 1312.61 -953.567 1331.83 -937.511C1367.56 -907.887 1412.79 -865.373 1444.68 -831.678C1462.31 -812.909 1484.02 -786.224 1499.63 -765.646C1514.1 -746.65 1532.19 -719.966 1545.53 -700.065C1561.82 -675.642 1581.49 -641.496 1594.15 -615.037C1604.33 -593.78 1618.12 -565.513 1626.94 -543.578C1636.67 -519.833 1648.2 -487.721 1655.89 -463.298C1676.47 -397.266 1685.97 -341.184 1690.94 -305.454C1700.44 -235.803 1700.44 -178.816 1699.53 -143.991C1698.63 -116.176 1696.14 -79.0893 1692.3 -51.5004C1686.42 -8.98634 1675.34 47.3221 1664.48 88.7055C1656.79 118.103 1643.68 156.321 1632.6 184.588C1625.36 203.132 1614.73 227.328 1606.59 245.42C1598 264.415 1585.11 289.064 1574.93 307.381C1566.79 322.08 1555.26 341.302 1546.21 355.549C1533.32 375.901 1515 402.133 1500.53 421.129C1486.96 438.994 1467.74 462.286 1452.82 479.021C1429.3 505.479 1404.42 530.806 1378.64 554.325C1359.65 571.511 1346.98 582.14 1334.55 592.09C1326.86 598.422 1307.41 613.347 1296.78 621.035C1281.63 631.89 1271.68 638.9 1261.05 645.911C1255.62 649.303 1248.61 654.052 1243.19 657.444C1237.76 660.836 1230.52 665.132 1225.1 668.525C1219.67 671.917 1212.21 676.213 1206.78 679.379C1195.25 685.937 1179.64 694.304 1167.88 700.41C1161.55 703.802 1152.73 708.099 1146.17 711.265C1142.78 712.848 1124.92 721.667 1098.01 732.974C1089.41 736.592 1077.88 741.115 1069.06 744.507C1059.79 748.125 1047.12 752.422 1037.63 755.814C1025.42 760.111 1009.13 765.312 996.696 768.93C984.484 772.322 967.976 777.071 955.765 780.011C934.734 784.76 906.692 791.092 885.662 794.71C852.419 800.137 807.87 805.112 774.402 807.147C743.647 808.956 702.263 809.861 671.509 807.374C645.503 805.338 610.677 803.755 585.124 799.233C564.093 795.614 535.825 791.318 515.021 787.021C490.145 781.82 457.355 773.679 433.159 765.99C391.097 752.422 336.145 730.26 295.44 712.622C272.374 702.445 242.75 685.937 221.041 673.047C199.558 660.384 170.838 642.971 151.164 627.82C114.53 599.778 66.362 561.561 33.3458 529.449C3.04324 499.825 -33.365 456.407 -60.2755 423.39C-75.2006 404.169 -92.3872 377.032 -105.729 357.132Z",
    stroke: "white",
    strokeOpacity: 0.03,
    strokeWidth: 1.85565,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorldbusiness);
export default __webpack_public_path__ + "static/media/worldbusiness.3600777b9e084b7797a0f8df2f30fcc7.svg";
export { ForwardRef as ReactComponent };